export const PageCollapseWidth = 1050;
